import styles from '../../css/MapUI.module.css';

export default function ToggleBtn({
	state,
	setState,
}){
	const isClicked = () => {
		setState({...state, containerShow: !state.containerShow, containerShow2: false, containerShow3: false})
	}
	return(
		<button type='button' className={`${styles.toggleBtn} ${state.containerShow ? styles.toggleBtnShow : styles.toggleBtnHide}`} onClick={isClicked}>
			입력검색 <img src={state.containerShow ? 'img/icon_arrow_left_white.png' : 'img/icon_arrow_right_white.png'} alt='toggleBtn'/>
		</button>
	)
}